import { render } from "./SirenSearchBarLoading.vue?vue&type=template&id=bb676ffe&scoped=true"
const script = {}

import "./SirenSearchBarLoading.vue?vue&type=style&index=0&id=bb676ffe&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb676ffe"]])

export default __exports__